<template>
  <div class="exam-results-container">
    <div class="page-header">
      <div class="breadcrumb">ນັກຮຽນ / <span>ປະກາດຜົນການສອບເສັງ</span></div>
      <div class="header-content">
        <h1>ປະກາດຜົນການສອບເສັງ</h1>
        <p>ສະຫຼຸບລາຍຊື່ນັກຮຽນທີ່ສອບເສັງໄດ້ ແລະ ສອບເສັງຕົກ ໂດຍອີງຕາມຄະແນນສະເລ່ຍ</p>
      </div>
    </div>

    <!-- ສ່ວນຄັດກອງ -->
    <div class="panel filter-panel mb-4">
      <div class="panel-body">
        <div class="field-row">
          <div class="form-group">
            <label><i class="fas fa-graduation-cap"></i> ຊັ້ນຮຽນ</label>
            <select v-model="filters.grade" @change="fetchResults">
              <option value="">-- ເລືອກຊັ້ນຮຽນ --</option>
              <option v-for="item in classList" :key="item.value" :value="item.value">{{ item.text }}</option>
            </select>
          </div>
          <div class="form-group">
            <label><i class="fas fa-calendar-alt"></i> ເດືອນ / ພາກຮຽນ</label>
            <select v-model="filters.month" @change="fetchResults">
              <option v-for="item in monthList" :key="item.value" :value="item.value">{{ item.text }}</option>
            </select>
          </div>
          <div class="form-group">
            <label><i class="fas fa-history"></i> ສົກຮຽນ</label>
            <select v-model="filters.academicYear" @change="fetchResults">
              <option v-for="item in accdList" :key="item.value" :value="item.text">{{ item.text }}</option>
            </select>
          </div>
          <div class="form-group">
            <label><i class="fas fa-door-open"></i> ຫ້ອງຮຽນ</label>
            <select v-model="filters.room_no" @change="fetchResults">
              <option value="">-- ທັງໝົດ --</option>
              <option v-for="n in 20" :key="n" :value="n">ຫ້ອງ {{ n }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div v-if="loading" class="text-center py-5">
      <i class="fas fa-spinner fa-spin fa-2x"></i>
      <p class="mt-2">ກຳລັງປະມວນຜົນຂໍ້ມູນ...</p>
    </div>

    <template v-else-if="allResults.length > 0">
      <div class="results-toolbar">
        <button class="btn-export" @click="exportToExcel">
          <i class="fas fa-file-excel"></i> ສົ່ງອອກ Excel
        </button>
      </div>

      <!-- ສ່ວນສະຫຼຸບຕົວເລກ -->
      <div class="kpi-grid">
        <div class="kpi-card blue">
          <div class="kpi-label">ນັກຮຽນທັງໝົດ</div>
          <div class="kpi-value">{{ allResults.length }}</div>
          <div class="kpi-badge">ຄົນ</div>
        </div>
        <div class="kpi-card green">
          <div class="kpi-label">ສອບເສັງໄດ້</div>
          <div class="kpi-value">{{ passedStudents.length }}</div>
          <div class="kpi-badge up">ເປີເຊັນ: {{ passRate }}%</div>
        </div>
        <div class="kpi-card red">
          <div class="kpi-label">ສອບເສັງຕົກ</div>
          <div class="kpi-value">{{ failedStudents.length }}</div>
          <div class="kpi-badge down">ຕ້ອງບຳລຸງ</div>
        </div>
      </div>

      <div class="two-col mt-4">
        <!-- ບັນຊີລາຍຊື່ຜູ້ເສັງໄດ້ -->
        <div class="panel">
          <div class="panel-head bg-success-light">
            <h3><i class="fas fa-check-circle text-success"></i> ລາຍຊື່ນັກຮຽນທີ່ສອບເສັງໄດ້ (ຄະແນນ >= 5)</h3>
          </div>
          <div class="panel-body">
            <div class="table-wrap">
              <table class="result-table">
                <thead>
                  <tr>
                    <th>ລຳດັບ</th>
                    <th>ຊື່ ແລະ ນາມສະກຸນ</th>
                    <th class="text-center">ຄະແນນ</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(s, idx) in passedStudents" :key="s._id">
                    <td>{{ idx + 1 }}</td>
                    <td class="font-bold">{{ s.firstNameLao }} {{ s.familyNameLao }}</td>
                    <td class="text-center"><span class="badge-score pass">{{ s.scores }}</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- ບັນຊີລາຍຊື່ຜູ້ເສັງຕົກ -->
        <div class="panel">
          <div class="panel-head bg-danger-light">
            <h3><i class="fas fa-times-circle text-danger"></i> ລາຍຊື່ນັກຮຽນທີ່ສອບເສັງຕົກ (ຄະແນນ &lt; 5)</h3>
          </div>
          <div class="panel-body">
            <div class="table-wrap">
              <table class="result-table">
                <thead>
                  <tr>
                    <th>ລຳດັບ</th>
                    <th>ຊື່ ແລະ ນາມສະກຸນ</th>
                    <th class="text-center">ຄະແນນ</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(s, idx) in failedStudents" :key="s._id">
                    <td>{{ idx + 1 }}</td>
                    <td class="font-bold">{{ s.firstNameLao }} {{ s.familyNameLao }}</td>
                    <td class="text-center"><span class="badge-score fail">{{ s.scores }}</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </template>

    <div v-else class="empty-state panel py-5 text-center">
      <i class="fas fa-clipboard-list fa-3x mb-3" style="opacity: 0.2"></i>
      <p>ກະລຸນາເລືອກເງື່ອນໄຂເພື່ອເບິ່ງຜົນການສອບເສັງ</p>
    </div>
  </div>
</template>

<script>
import api from '@/utils/api';
import * as XLSX from 'xlsx';

export default {
  name: 'ExamResultsAnnouncementPage',
  data() {
    return {
      loading: false,
      filters: { grade: '', month: '9', academicYear: '2025-2026', room_no: 1 },
      classList: [],
      accdList: [],
      monthList: [
         { value: 'S1', text: 'ພາກຮຽນ 1' },   { value: 'S2', text: 'ພາກຮຽນ 2' }
      ],
      allResults: [],
      user: JSON.parse(localStorage.getItem('user-info') || '{}')
    };
  },
  computed: {
    passedStudents() {
      return this.allResults.filter(s => (parseFloat(s.scores) || 0) >= 5);
    },
    failedStudents() {
      return this.allResults.filter(s => (parseFloat(s.scores) || 0) < 5);
    },
    passRate() {
      if (this.allResults.length === 0) return 0;
      return Math.round((this.passedStudents.length / this.allResults.length) * 100);
    }
  },
  async mounted() {
    await this.fetchClassList();
    await this.fetchAccdList();
  },
  methods: {
    async fetchClassList() {
      const res = await api.get('/getItems/class_list/class_desc_lao/id');
      this.classList = res.data;
    },
    async fetchAccdList() {
      const res = await api.get('/getItems/accd/accd/id');
      this.accdList = res.data.sort((a, b) => b.text.localeCompare(a.text));
    },
    async fetchResults() {
      if (!this.filters.grade) return;
      this.loading = true;
      try {
        const res = await api.get('/scores/report', {
          params: {
            grade: this.filters.grade,
            month: this.filters.month,
            academicYear: this.filters.academicYear,
            school_id: this.user.school_id,
            room_no: this.filters.room_no
          }
        });
        if (res.data.code === 1) {
          this.allResults = res.data.rows;
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    exportToExcel() {
      if (this.allResults.length === 0) {
        alert('ບໍ່ມີຂໍ້ມູນທີ່ຈະສົ່ງອອກ.');
        return;
      }

      try {
        const gradeObj = this.classList.find(c => c.value == this.filters.grade);
        const gradeName = gradeObj ? gradeObj.text : this.filters.grade;
        const monthObj = this.monthList.find(m => m.value === this.filters.month);
        const monthName = monthObj ? monthObj.text : this.filters.month;

        const header = ['ລຳດັບ', 'ຊື່ ແລະ ນາມສະກຸນ', 'ຄະແນນ', 'ຜົນ'];
        const data = [
          ...this.passedStudents.map((s, i) => [i + 1, `${s.firstNameLao} ${s.familyNameLao}`, s.scores, 'ສອບເສັງໄດ້']),
          ...this.failedStudents.map((s, i) => [i + 1, `${s.firstNameLao} ${s.familyNameLao}`, s.scores, 'ສອບເສັງຕົກ']),
        ];

        const ws = XLSX.utils.aoa_to_sheet([
          [`ປະກາດຜົນການສອບເສັງ - ຊັ້ນ ${gradeName} - ${monthName} - ສົກຮຽນ ${this.filters.academicYear}`],
          [`ນັກຮຽນທັງໝົດ: ${this.allResults.length} ຄົນ, ສອບເສັງໄດ້: ${this.passedStudents.length} ຄົນ (${this.passRate}%), ສອບເສັງຕົກ: ${this.failedStudents.length} ຄົນ`],
          [],
          header,
          ...data,
        ]);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'ຜົນການສອບເສັງ');

        const ts = new Date().toISOString().slice(0, 10);
        const filename = `ຜົນການສອບເສັງ_${gradeName}_${monthName}_${this.filters.academicYear}_${ts}.xlsx`;
        XLSX.writeFile(wb, filename);
      } catch (error) {
        console.error('Excel Export Error:', error);
        alert('ເກີດຂໍ້ຜິດພາດໃນການສົ່ງອອກໄຟລ໌ Excel');
      }
    }
  }
};
</script>

<style scoped>
.exam-results-container { animation: fadeIn 0.4s ease; max-width: 1200px; margin: 0 auto; }
.field-row { display: grid; grid-template-columns: repeat(4, 1fr); gap: 15px; }
.form-group label { display: block; font-size: 13px; font-weight: 600; margin-bottom: 5px; color: var(--text2); }
.form-group select { width: 100%; padding: 10px; border-radius: 8px; border: 1px solid var(--border); font-size: 14px; }

.results-toolbar { display: flex; justify-content: flex-end; margin-bottom: 12px; }
.btn-export {
  background: #10b981; color: white; border: none; border-radius: 8px; cursor: pointer;
  font-weight: 600; padding: 10px 18px; font-size: 14px; display: flex; align-items: center; gap: 8px; transition: 0.2s;
}
.btn-export:hover:not(:disabled) { background: #059669; transform: translateY(-2px); box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3); }
.btn-export:disabled { opacity: 0.6; cursor: not-allowed; }

.bg-success-light { background-color: #f0fdf4 !important; border-bottom: 2px solid #bbf7d0 !important; }
.bg-danger-light { background-color: #fef2f2 !important; border-bottom: 2px solid #fecaca !important; }

.result-table { width: 100%; border-collapse: collapse; }
.result-table th { text-align: left; font-size: 11px; color: var(--text3); text-transform: uppercase; padding: 10px; border-bottom: 1px solid var(--border); }
.result-table td { padding: 12px 10px; border-bottom: 1px solid #f1f5f9; font-size: 14px; }
.font-bold { font-weight: 600; color: var(--text1); }

.badge-score {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 6px;
  font-weight: 700;
  min-width: 45px;
}
.badge-score.pass { background: #dcfce7; color: #166534; }
.badge-score.fail { background: #fee2e2; color: #991b1b; }

.table-wrap { max-height: 500px; overflow-y: auto; }

@media (max-width: 1024px) {
  .two-col { grid-template-columns: 1fr; gap: 20px; }
  .field-row { grid-template-columns: 1fr 1fr; }
}

@keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
</style>